import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import JadeSoftTeamImage from '../../../assets/images/home/JadeSoftTeam.png';


const StyledJadeSoftTeam = styled(Box)(({ theme }) => ({
  //   minHeight: 'calc(190vh - 82px)',
  position: 'relative',
  overflow: 'visible',
  justifyContent: 'center',
  //   backgroundImage: `url(${JadeSoftTeamImage})`,
  //   backgroundPosition: 'center',
  //   backgroundRepeat: 'no-repeat',
  //   backgroundSize: 'cover',
  // background: `url(${JadeSoftTeamImage}) lightgray 50% / contain no-repeat`,
  // backgroundColor: '#ffffff',
  background: 'transparent',
  width: '100%',
  '& .homeBg': {
    position: "relative",
    width: "100%",
    height: "650px",
    // backgroundImage: `url(${JadeSoftTeamImage})`, // Replace with your image URL
    // backgroundSize: "cover",
    // backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#000",
    textAlign: "center",
    overflow: "hidden",

    // '& .videoElement': {
    //   position: 'absolute',
    //   top: 0,
    //   left: 0,
    //   height: '130%',
    //   width: '100%',
    //   objectFit: 'cover',
    //   // zIndex: -1,
    // },

    // '& .bgImage': {
    //   width: '100%',
    //   height: '750px',
    //   objectFit: 'contain',
    //   position: 'absolute',
    // }
  },

  '& .homeContent': {
    // position: 'absolute',
    height: '100%',
    width: '100%',
    zIndex: 1 /* Ensures content is above the video */,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(0),
    // paddingLeft: '20%',
    padding: '2% 10% 5% 10%',
    //  background: `url(${JadeSoftTeamImage}) lightgray 50% / contain no-repeat`,

    '& .bannerText': {
      background: theme.customGradients.primary,
      '-webkit-background-clip': 'text',
      '-webkit-text-fill-color': 'transparent',
      boxShadow: theme.palette.boxShadow.secondary,
      font: theme.typography.h3.font,
      fontWeight: 400,
      textAlign: 'center',
    },

    [theme.breakpoints.down('lg')]: {
      paddingLeft: 1,
      '& .iconBrandLogo': {
        width: '300px',
        height: '100px',
      },
    },
  },

  [theme.breakpoints.down('lg')]: {
    // minHeight: '300vh',
    margin: theme.spacing(0),
    // width: '335px',

    '& .homeBg': {
      height: "880px",
      '& .bgImage': {
        background: `url(${JadeSoftTeamImage}) lightgray 50% / contain no-repeat`,
        height: '120%',
        objectFit: 'none',
        position: 'absolute',
      }
    },

    '& .homeContent': {
      // marginTop: theme.spacing(0),
      // marginBottom: theme.spacing(0),
      marginTop: '-100px',
      justifyContent: 'center',
      padding: '0 5%',

      '& .bannerText': {
        margin: theme.spacing(0, 1),
        font: theme.typography.h6.font,
        fontWeight: `${500} !important`,
      },
    },

    '.cardMedia': {
      width: '400px',
      height: '216px',
    },
    // '& .carousel': {
    //   position: 'relative',
    //   width: '80px',
    //   height: `${CARD_SIZE}`,
    //   perspective: '500px',
    //   transformStyle: 'preserve-3d'
    // },

    '& .carousel': {
      width: '334px !important',
      height: '400px'
    },

    '& .carousel-root': {
      height: '450px !important',
      display: 'flex',
      justifyContent: 'center'
    },

    '& .carousel-status': {
      display: 'none'
    },

    '& .control-dots': {
      marginBottom: localStorage.getItem('i18nextLng') === 'en-US' ? 'unset' : '35px',
      // top: '286px'
    },

    '& .dot': {
      background: '#000 !important',
      opacity: '1 !important',
      boxShadow: 'unset !important',
    },

    '& .dot.selected': {
      background: '#00FF00 !important',
      opacity: '1 !important'
    }
  },

  '@media (max-width: 390px)': {
    '& .control-dots': {
      // top: '287px'
    },
  },

  '@media (max-width: 375px)': {
    '& .control-dots': {
      // top: '287px'
    },
  }
}));

export default StyledJadeSoftTeam;
